export default "/assets/images/highway-pollution-video.34a4d8c3034df82d.mp4";